import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, Validators, FormControl } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DataSource } from "@angular/cdk/table";
import { AllowableFeesService } from "./allowable-fees.service";
import { SessionService } from "../service/session.service";
export interface UserData {
    id: string;
    name: string;
    email: string;
    lastLogin: Date;
}

/** Constants used to fill up our data base. */
const COLORS: string[] = [
    "maroon",
    "red",
    "orange",
    "yellow",
    "olive",
    "green",
    "purple",
    "fuchsia",
    "lime",
    "teal",
    "aqua",
    "blue",
    "navy",
    "black",
    "gray",
];
const NAMES: string[] = [
    "Maia",
    "Asher",
    "Olivia",
    "Atticus",
    "Amelia",
    "Jack",
    "Charlotte",
    "Theodore",
    "Isla",
    "Oliver",
    "Isabella",
    "Jasper",
    "Cora",
    "Levi",
    "Violet",
    "Arthur",
    "Mia",
    "Thomas",
    "Elizabeth",
];

/**
 * @title Data table with sorting, pagination, and filtering.
 */

@Component({
    selector: "app-allowable-fees",
    templateUrl: "./allowable-fees.component.html",
    styleUrls: ["./allowable-fees.component.scss"],
})
export class AllowableFeesComponent implements OnInit {
    displayedColumns: string[] = ["id", "title", "note", "fees"];

    dataSource: MatTableDataSource<UserData>;
    mobnumPattern = "^(d{3})sd{3}-d{4}";

    add_Borrower = new FormGroup({
        title: new FormControl(null, [Validators.required]),
        note: new FormControl(null, [Validators.maxLength(1000)]),
        fee: new FormControl(null),
        id: new FormControl(null),
    });

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    isList: boolean = true;
    isAdd: boolean = false;
    isEdit: boolean = false;
    isDelete: boolean = false;
    submitted: boolean = false;
    favoriteSeason: string;
    userList: any = {};
    userDetail: any = {};
    loading = false;
    status: any = ["Blocked", "Active"];
    roles: any = [
        { Key: "1", Value: "authenticated user" },
        { Key: "2", Value: "Administrator" },
        { Key: "3", Value: "Consultants" },
        { Key: "4", Value: "General Contractors" },
        { Key: "5", Value: "Borrower" },
        { Key: "6", Value: "Loan Officer" },
        { key: "7", Value: "Loan Processor" },
        { key: "8", Value: " Notify user of new account" },
        { key: "9", Value: "Draw Administrator" },
    ];
    constructor(
        private _bservice: AllowableFeesService,
        private sessionService: SessionService
    ) {
        // Create 100 users
        // Assign the data to the data source for the table to render
    }

    ngOnInit() {
        if (this.sessionService.get("userInfo") !== undefined) {
            this.userDetail = JSON.parse(this.sessionService.get("userInfo"));
        }
        this.GetUserList();
    }

    applyFilter(filterValue) {
        const target = filterValue as HTMLInputElement;
        const targetValue = target.value;
        this.dataSource.filter = targetValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    borrowerList() {
        this.isEdit = false;
        this.isAdd = false;
        this.isList = true;
    }

    showAddForm() {
        this.isAdd = true;
        this.isList = false;
    }

    // ValidatePartnerPass()
    // {

    //   const password = this.add_Borrower.controls.password.value;
    //   const repeatPassword = this.add_Borrower.controls.confirmPassword.value;

    //   if (repeatPassword !== password) {

    //     this.add_Borrower.controls['confirmPassword'].setErrors({'incorrect': true});

    //   }
    //   else {

    //     this.add_Borrower.controls['confirmPassword'].setErrors(null);

    //   }
    // }

    // ValidatePartnerPassEdit()
    // {

    //   const password = this.add_Borrower.controls.editPassword.value;
    //   const repeatPassword = this.add_Borrower.controls.editConfirmPassword.value;

    //   if (repeatPassword !== password) {

    //     this.add_Borrower.controls['editConfirmPassword'].setErrors({'incorrect': true});

    //   }
    //   else {

    //     this.add_Borrower.controls['editConfirmPassword'].setErrors(null);

    //   }
    // }

    SaveBorrower() {
        this.submitted = true;
        if (this.add_Borrower.invalid) {
            return;
        } else {
            this.submitted = false;
            const formData = this.add_Borrower.value;
            if (formData.id == null && !this.isEdit) {
                this.loading = true;
                const data = {
                    Title: formData.title,
                    Notes: formData.note,
                    Fees: formData.fee,
                    CreatedBy: "CreatedBy",
                    CreatedDate: "CreatedDate",
                    UpdateDate: "UpdateDate",
                    UpdatedBy: "UpdatedBy",
                };
                this._bservice.AddBorrower(data).subscribe(
                    (response) => {
                        this.sessionService.notifier.notify(
                            "success",
                            "Allowable Fees added successfully."
                        );
                        this.isList = true;
                        this.isAdd = false;
                        this.formReset();
                        this.GetUserList();
                        this.loading = false;
                    },
                    (error) => {
                        this.sessionService.notifier.notify(
                            "error",
                            error.error.message
                        );
                        this.loading = false;
                    }
                );
            } else {
                this.loading = true;

                const data1 = {
                    Id: formData.id,
                    Title: formData.title,
                    Notes: formData.note,
                    Fees: formData.fee,
                    CreatedBy: "CreatedBy",
                    CreatedDate: "CreatedDate",
                    UpdateDate: "UpdateDate",
                    UpdatedBy: "UpdatedBy",
                };

                this._bservice.UpdateBorrower(data1).subscribe(
                    (response) => {
                        this.sessionService.notifier.notify(
                            "success",
                            "Allowable Fees updated successfully."
                        );

                        this.isList = true;
                        this.isAdd = false;
                        this.isEdit = false;
                        this.formReset();
                        this.GetUserList();
                        this.loading = false;
                    },
                    (error) => {
                        this.sessionService.notifier.notify(
                            "error",
                            error.error.message
                        );
                        this.loading = false;
                    }
                );
            }
        }
    }

    nextPage(event: PageEvent) {}

    GetUserList() {
        this.loading = true;
        const data = {
            EmailId: "",
            PageSize: 100000,
            LastEvaluatedKey: 0,
            UserType: this.sessionService.userType[0].Value,
        };
        this._bservice.AllowableFeesList(data).subscribe(
            (response) => {
                if (response != null) {
                    this.userList = response;

                    this.userList.Count = this.userList.Count + 2;
                    const users = Array.from(
                        { length: this.userList.Count },
                        (_, k) => createNewUser(k, this.userList)
                    );
                    this.dataSource = new MatTableDataSource(users);
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;

                    this.loading = false;
                }
            },
            (error) => {}
        );
    }

    deleteAllowableFees(feesId) {
        if (confirm("Are you sure you want to delete allowable fees!")) {
            this._bservice.DeleteAllowableFees(feesId).subscribe(
                (response) => {
                    this.sessionService.notifier.notify(
                        "success",
                        "Allowable fees deleted successfully."
                    );
                    this.isEdit = false;
                    this.isList = true;
                    this.isAdd = false;
                    this.GetUserList();
                    this.loading = false;
                },
                (error) => {
                    this.sessionService.notifier.notify(
                        "error",
                        error.error.message
                    );
                    this.loading = false;
                }
            );
            window.scroll(0, 0);
        }
    }

    EditUser(item) {
        if (item.Title == "Mileage Fees") {
            return;
        } else if (item.Title == "Draw Fee") {
            this.isEdit = true;
            this.isDelete = false;
            this.isList = false;

            this.add_Borrower.setValue({
                title: item.Title,
                note: item.Notes,
                fee: item.Fees,
                id: item.Id,
            });
        } else {
            this.isEdit = true;
            this.isDelete = true;
            this.isList = false;

            this.add_Borrower.setValue({
                title: item.Title,
                note: item.Notes,
                fee: item.Fees,
                id: item.Id,
            });
        }
    }

    formReset() {
        this.add_Borrower.reset();
    }
}

/** Builds and returns a new User. */
function createNewUser(id: number, userList): UserData {
    const name =
        NAMES[Math.round(Math.random() * (NAMES.length - 1))] +
        " " +
        NAMES[Math.round(Math.random() * (NAMES.length - 1))].charAt(0) +
        ".";
    if (userList.Items[id] !== undefined) {
        userList.Items[id].id = id + 1;
        return userList.Items[id];
    }
}
